import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrutch = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1,.cls-2{fill:none;}.cls-2{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			width: 24,
			height: 24
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-2",
			points: "13.49 6.7 14.52 10.52 14.15 16.88"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-2",
			points: "9.63 7.74 10.65 11.55 14.15 16.88"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-2",
			d: "M14.15,16.88l1,3.86"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-2",
			d: "M14.22,21l1.93-.52"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-2",
			d: "M10.67,11.6l3.86-1"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-2",
			d: "M14.09,5.75A26.13,26.13,0,0,1,8.5,7.13a1.73,1.73,0,0,1-2-1.33h0A1.54,1.54,0,0,1,7.94,4.16,23.07,23.07,0,0,0,13,3a1.62,1.62,0,0,1,2,.8h0A1.45,1.45,0,0,1,14.09,5.75Z"
		})
	]
});
export default SvgCrutch;
